export const environment = {
  apiUrl: 'https://guyana.localtest.me/api/',
  enableRegistration: false,
  production: true,
  hideLogin: false,
  enableSentry: true,
  debug: false,
  appInsights: {
    instrumentationKey: 'cc80a231-2e02-4a14-94cc-c7433618b7d4',
  },
};
